import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion";

import CheckBoxRefinementList from "../../Components/CheckBoxRefinementList";
import MembershipFilter from "../../Components/DirectoryPanel/MembershipFilter";
import LocationFilter from "../../Components/DirectoryPanel/LocationFilter";
import {useTranslation} from "react-i18next";
import PartnerContactPanel from "../PartnerContact";

export default function PartnerFilterPan(props) {
    const {t, i18n} = useTranslation();
    const projectSupportUrl = window.win_project_support_redirect;
    const tabs = [
        {
            id: 1,
            label: 'Filter By Material Types',
            description: "Content of Tab 3",
            filterItem: (
                <div className="form__row">
                    <div className="form__group">
                        <CheckBoxRefinementList
                            limit={20}
                            operator="or"
                            attribute="material_type_names"
                            initialFacets={window.all_material_types}
                        />
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div className="filters accordion">
            <Accordion preExpanded={[1]} allowMultipleExpanded >
                {tabs.map((tab) => (
                    <AccordionItem key={tab.id} uuid={tab.id}>
                        <AccordionItemHeading>
                            <AccordionItemButton>{tab.label}</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="filterItem">{tab.filterItem}</div>
                        </AccordionItemPanel>
                    </AccordionItem>
                ))}
            </Accordion>
            <div className="form__group accordion__section">
                <div className="form__entry">
                    <p>
                        Select the material types you wish to find matching Manufacturers & Suppliers and then click the compose message button.
                    </p>
                </div>
            </div>
        </div>
    );
}
